import { api } from '../../services/api';
import { GET_NOTIFICATION_FAILURE, GET_NOTIFICATION_SUCCESS, SET_LOADING } from '../reducers/types';

export const getNotification = () => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const response = await api.get('/notificaciones');
    dispatch({ type: GET_NOTIFICATION_SUCCESS, payload: response.data.notificaciones });
  } catch (error) {
    dispatch({ type: GET_NOTIFICATION_FAILURE, payload: error });
  }
};
